__turbopack_context__.v({
  "onSaleFilterTrigger": "WGCsQW_onSaleFilterTrigger",
});
